import { ReactNode, FC } from 'react';
import {
  Provider,
  Root,
  Trigger,
  Portal,
  Content,
  Arrow,
} from '@radix-ui/react-tooltip';
import styled from 'styled-components';
import tw from 'twin.macro';

import { TooltipPosition } from '../enums';

const StyledTrigger = styled(Trigger)<{ $disabled?: boolean }>`
  ${tw`rounded-full cursor-pointer`};

  ${({ $disabled }) =>
    $disabled &&
    tw`pointer-events-none active:outline active:outline-slate-800/20 active:outline-offset-2`};
`;

const StyledContent = styled(Content)`
  ${tw`font-light text-slate-50 select-none rounded-lg bg-slate-800 px-2.5 py-2 max-w-96 text-xs z-50 leading-none shadow-sm z-10 will-change-[transform,opacity]`}
`;

const StyledArrow = styled(Arrow)`
  ${tw`fill-slate-800`}
`;

interface Props {
  content?: string;
  disabled?: boolean;
  side?: TooltipPosition;
  children?: ReactNode;
}

const TooltipInfo: FC<Props> = ({
  content,
  disabled,
  side = TooltipPosition.top,
  children,
}) => {
  const lines = content?.split('\n') || [];
  return (
    <Provider delayDuration={200}>
      <Root>
        <StyledTrigger $disabled={disabled} asChild>
          {children}
        </StyledTrigger>
        {content && (
        <Portal>
          <StyledContent sideOffset={5} side={side}>
            {lines.map((line, index) => (
              <div key={index}>{line}</div>
            ))}
            <StyledArrow />
          </StyledContent>
        </Portal>
        )}
      </Root>
    </Provider>
  );
};

export default TooltipInfo;
